import { Accordion, AccordionDetails, AccordionSummary, Avatar, Grid, Pagination, Stack, Typography } from '@mui/material'
import ProjectRow from '../../album/row/ProjectRow'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import React, { useMemo } from 'react';


interface ArtistTimelineProps extends MKProps {
    tracks: [Track],
}

const ArtistTimeline = ({tracks}: ArtistTimelineProps) => {
    const [page, setPage] = React.useState(1);
    const [expanded, setExpanded] = React.useState<string | false>('panel0');

    const handleChange = 
    (event: React.ChangeEvent<unknown>, value: number) => {
        event.stopPropagation()
        setPage(value)
    }
         
    const handleChangePannel =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        event.stopPropagation()
        setExpanded(newExpanded ? panel : false);
        setPage(1)
    }

    const tracksSorted = useMemo(() => {
        return [...tracks].reduce((acc: any, current: any) => { 
            const x = acc.find((item: any) => item.album?._id === current.album?._id)
            if (!x) { 
                return acc.concat([current]) 
            } else { 
                return acc 
            }
        }, [])
        .sort((a: any, b: any) => new Date(b.apple_release_date).getTime() - new Date(a.apple_release_date).getTime())
        .reduce((acc: any, current: any) => {
            let date: string = `${new Date(current.apple_release_date).getFullYear()}`
            if (!acc.find((item: any) => item.date === date)) {
                acc.push({date: date, tracks: []})
            }
            acc.find((item: any) => item.date === date).tracks.push(current)
            return acc
        }, [])
        .sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())
    }, [tracks])

    return (
        <Grid size={12} sx={{height: '100%', overflow: 'hidden', overflowY: 'scroll', pb: 8}}>
            {
                tracksSorted.filter((track: any) => track.apple_release_date !== null)
                .map((tracksByDate: any, i: number) => 
                    <Accordion key={i+Date()} expanded={expanded === `panel${i}`} sx={{ backgroundColor: '#00000000!important'}} onChange={handleChangePannel(`panel${i}`)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon htmlColor='white'/>}
                            aria-controls={`panel${i}-content`}
                            id={`panel${i}-header`}
                            sx={{backgroundColor: `${colorByPos(i)}!important`, '& .MuiAccordionSummary-contentGutters': {width: "96%"}}}
                        >
                            <Stack direction={'row'} alignItems={'center'} spacing={2} sx={{width: '100%'}}>
                                <Typography variant='h3' color='white' sx={{fontWeight: '600'}}>{tracksByDate.date}</Typography>
                                <Stack direction={'row'} sx={{overflow: 'hidden', overflowX: 'scroll', width: '100%'}} spacing={2}>
                                {
                                    tracksByDate.tracks.map( (track: Track, j: number) => <Avatar onClick={(e) => handleChange(e, j + 1)} sx={{border: page === (j + 1) && expanded === `panel${i}` ? '2px solid white' : 'none'}} variant='rounded' key={track._id+Date.now()} src={track.album?.apple_artwork_url?.replace('{w}', '800').replace('{h}', '800')}/>)
                                }
                                </Stack>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: '#00000000!important', p: 0}}>
                        {
                            tracksByDate.tracks.slice(page-1, page).map((track: Track, i: number) => 
                                <ProjectRow 
                                    key={track?._id + `${i}` + Date()} 
                                    album={track.album} 
                                    tracks={tracks.filter((atrack: Track) => atrack.album?._id === track.album?._id).length > 0 ? tracks.filter((atrack: Track) => atrack.album?._id === track.album?._id) : [track]}/>
                            )
                        }
                            <Stack alignItems={'center'} sx={{pt: 2}}>
                                <Pagination count={tracksByDate.tracks.length} variant='outlined' color='secondary' page={page} sx={{'& button': {color: '#FFFFFF'}}} onChange={handleChange} />
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                )
            }
        </Grid>
    )
}

export default ArtistTimeline

const colorByPos = (position: number) => {
    return '#17043C'
    // switch (position%4) {
    // case 0: return '#F2CE1E'
    // case 1: return '#36B0B6'
    // case 2: return '#E5591E'
    // case 3: return '#17043C'
    // default: return '#FFFFFF'
    // }
}
